import {
  YEARLY_MAX_COMPLIMENTARY_15,
  type YearlyMaxComplimentaryDiscount,
} from '../contracts/yearly-max-complimentary-discount';

/**
 * FE request of the yearly Max complimentary coupon. The server still checks
 * complimentary cycle, Max yearly target, coupon provision, and prior redeem.
 *
 * MOBILE-PARITY-DEBT(GRO-4717): eligibility (trial-end flag + complimentary
 * cycle + yearly Max target) is computed client-side before apply_discount is
 * sent. Mobile must mirror this or wait for a backend-materialized eligibility
 * field / server-side auto-apply.
 */
export function resolveYearlyMaxComplimentaryDiscount({
  isTrialEndEnabled,
  isComplimentaryUsage,
  isYearlyMaxTarget,
}: {
  /** `release-growth-heidi-2-trial-end`. */
  isTrialEndEnabled: boolean;
  /** Live uncapped Heidi 2 complimentary credit cycle. */
  isComplimentaryUsage: boolean;
  /** Checkout / portal / team-upgrade targets yearly Max. */
  isYearlyMaxTarget: boolean;
}): YearlyMaxComplimentaryDiscount | undefined {
  if (!isTrialEndEnabled || !isComplimentaryUsage || !isYearlyMaxTarget) {
    return undefined;
  }
  return YEARLY_MAX_COMPLIMENTARY_15;
}
